export type LocalizationValues = {
    [key in LocalizedText]: string
}

export enum LocalizedText {
    Search = 'SEARCH',
    LastUpdated = 'LAST_UPDATED',
    Name = 'NAME',
    Status = 'STATUS',
    New = 'NEW',
    All = 'ALL',
    SEARCH_CANDIDATE = 'SEARCH_CANDIDATE',
    COMPLETED = 'COMPLETED',
    CANDIDATES = 'CANDIDATES',
    LOCATION = 'LOCATION',
    SOURCE = 'SOURCE',
    APPLIED_DATE = 'APPLIED_DATE',
    EMAIL = 'EMAIL',
    PHONE = 'PHONE',
    CURRENT_TITLE = 'CURRENT_TITLE',
    WORK_HISTORY = 'WORK_HISTORY',
    DATATABLE_VIEW = 'DATATABLE_VIEW',
    WORKFLOW_STATUS = 'WORKFLOW_STATUS',
    SELECT_CANDIDATE = 'SELECT_CANDIDATE',
    APPLIED_FOR = 'APPLIED_FOR',
    VIEW_DETAILS = 'VIEW_DETAILS',
    STRONG_MATCH = 'STRONG_MATCH',
    CANDIDATE_NAME = 'CANDIDATE_NAME',
    APPLICATION_STATUS = 'APPLICATION_STATUS',
    CANDIDATE_STATUS = 'CANDIDATE_STATUS',
    TALENT_FIT = 'TALENT_FIT',
    ALL_CANDIDATES = 'ALL_CANDIDATES',
    MATCHES = 'MATCHES',
    NOT_MATCHES = 'NOT_MATCHES',
    NO_MATCH_RUN = 'NO_MATCH_RUN',
    I18N_ANY = 'I18N_ANY',
    I18N_ALL = 'I18N_ALL',
    I18N_SELECTED = 'I18N_SELECTED',
    HIRE_CANCEL = 'HIRE_CANCEL',
    COMMON_REQUISITIONS = 'COMMON_REQUISITIONS',
    ADDTOREQ_ID = 'ADDTOREQ_ID',
    COMMON_LOCATION = 'COMMON_LOCATION',
    CATEGORY = 'CATEGORY',
    ADD_TO_REQUISITION = 'ADD_TO_REQUISITION',
    CANDIDATES_ADDED_SINGLE = 'CANDIDATES_ADDED_SINGLE',
    CANDIDATES_ADDED_MULTIPLE = 'CANDIDATES_ADDED_MULTIPLE',
    CANDIDATES_NOT_ADDED_TO_REQ = 'CANDIDATES_NOT_ADDED_TO_REQ',
    CANDIDATES_ALREADY_ASSOCIATED_TO_REQ = 'CANDIDATES_ALREADY_ASSOCIATED_TO_REQ',
    JV_ADDTOREQ_CONTROLLER_NOT_ADDED_TO_REQUISITION = 'JV_ADDTOREQ_CONTROLLER_NOT_ADDED_TO_REQUISITION',
    COMMON_OK = 'COMMON_OK',
    I18N_CANDIDATES_ADD_TO_REQ_MSG = 'I18N_CANDIDATES_ADD_TO_REQ_MSG',
    APPLICANT_JOBLIST_SELECT_A_REQUISITION = 'APPLICANT_JOBLIST_SELECT_A_REQUISITION',
    I18N_CANDIDATES_COMMON = 'I18N_CANDIDATES_COMMON',
    JV_MOVE_CANDIDATE_ERROR = 'JV_MOVE_CANDIDATE_ERROR',
    JV_APPLICANT_CHANGE_STATUS_REQUISITION_ERROR = 'JV_APPLICANT_CHANGE_STATUS_REQUISITION_ERROR',
    CANDIDATES_MOVE_MODAL_TITLE = 'CANDIDATES_MOVE_MODAL_TITLE',
    I18N_CANDIDATES_MOVE_MSG = 'I18N_CANDIDATES_MOVE_MSG',
    ADMIN_TAG_CANDIDATE_MOVE_CAND = 'ADMIN_TAG_CANDIDATE_MOVE_CAND',
    CANDIDATES_NOT_MOVED_TO_REQ = 'CANDIDATES_NOT_MOVED_TO_REQ',
    DUPLICATE_MODAL_TITLE_SINGLE = 'DUPLICATE_MODAL_TITLE_SINGLE',
    DUPLICATE_MODAL_TITLE_MULTIPLE = 'DUPLICATE_MODAL_TITLE_MULTIPLE',
    SERVER_ERROR = 'SERVER_ERROR',
    CANDIDATE_DELETE_CANDIDATE_MSG1 = 'CANDIDATE_DELETE_CANDIDATE_MSG1',
    I18N_CANDIDATE_MOVE_AND_REJECT = 'I18N_CANDIDATE_MOVE_AND_REJECT',
    I18N_CANDIDATE_BTN_MOVE_REJECT = 'I18N_CANDIDATE_BTN_MOVE_REJECT',
    APPLICANT_APPLICANTGRID_MOVE_CANDIDATE = 'APPLICANT_APPLICANTGRID_MOVE_CANDIDATE',
    CANDIDATES_MOVE_OPTION_LABEL = 'CANDIDATES_MOVE_OPTION_LABEL',
    CANDIDATES_MOVE_OPTION_REJECT = 'CANDIDATES_MOVE_OPTION_REJECT',
    I18N_REJECT_MODAL_LABEL = 'I18N_REJECT_MODAL_LABEL',
    CANDIDATES_MOVE_OPTION_DELETE = 'CANDIDATES_MOVE_OPTION_DELETE',
    I18N_DELETE_MODAL_LABEL = 'I18N_DELETE_MODAL_LABEL',
    COMMON_MOVE = 'COMMON_MOVE',
    REJECT_CANDIDATES = 'REJECT_CANDIDATES',
    REJECT_CANDIDATE = 'REJECT_CANDIDATE',
    COMMON_VIEW_DATATABLE = 'COMMON_VIEW_DATATABLE',

    // Criteria Engine
    ConditionLabel = 'CONDITIONLABEL',
    CriteriaEngine = 'CRITERIAENGINE',
    SetupConditions = 'SETUPCONDITIONS',
    CancelOfferForm = 'CANCELOFFERFORM',
    UnsavedChanges = 'UNSAVEDCHANGES',
    SaveAsDraft = 'SAVEASDRAFT',
    ConfigureConditionsDesc = 'CONFIGURECONDITIONSDESCRIPTION',
    DeleteGroupCondition = 'DELETEGROUPCONDITION',
    AddGroupCondition = 'ADDNEWCONDITIONGROUP',
    AddNewSubCondition ='ADDNEWSUBCONDITION',
    SelectFieldType = 'ADMINSELECTFIELDTYPE',
    FieldValue = 'ADMINFIELDVALUE',
    SelectFieldValue = 'ADMINSELECTFIELDVALUE',
    NoResults = 'ADMINNORESULTS',
    ValueLabel = 'ADMINVALUELABEL',
    AndLabel = 'ADMINANDLABEL',
    ErrorSaveAsDraft = 'ADMINERRORSAVEASDRAFT',
    InvalidForm = 'ADMINCRITERIAINVALIDFORM',
    SuccessSaveAsDraft = 'ADMINCRITERIASAVEASDRAFTSUCCESS',
    SkipThisStep = 'ADMINCRTIERIASKIPTHISSTEP',
    OperatorAnd = 'ADMINOPERATORAND',
    OperatorOr = 'ADMINOPERATOROR',
    OperatorGreaterThan = 'ADMINOPERATORGREATERTHAN',
    OperatorLessThan = 'ADMINOPERATORLESSTHAN',
    OperatorEqual = 'ADMINOPERATOREQUAL',
    OperatorNotEqual = 'ADMINOPERATORNOTEQUAL',
    OperatorBetween = 'ADMINOPERATORBETWEEN',
    OperatorNotBetween = 'ADMINOPERATORNOTBETWEEN',
    OperatorAny = 'ADMINOPERATORANY',
    OperatorNone = 'ADMINOPERATORNONE',
    OperatorSpecificDate = 'ADMINOPERATORSPECIFICDATE',
    OperatorCustomRange = 'ADMINOPERATORCUSTOMRANGE',
    OperatorBefore = 'ADMINOPERATORBEFORE',
    OperatorAfter = 'ADMINOPERATORAFTER',

    // NATIVE ESIG
    CreateSignature = 'CREATESIGNATURE',
    TodaysDate = 'TODAYSDATE',
    FullLegalName = 'FULLLEGALNAME',
    Initials = 'INITIALS',
    Preview = 'PREVIEW',
    OfferLetter = 'NATIVEESIGNOFFERLETTER',
    DownloadOfferLetter = 'NATIVEESIGNDOWNLOADOFFERLETTER',
    DownloadOfferLetterFileName = 'NATIVEESIGNDOWNLOADOFFERLETTERFILENAME',
    PageXofY = 'NATIVEESIGNPAGEXOFY',
    LegalRepresentation = 'LEGALREPRESENTATION',
    SignElectronically = 'SIGNELECTRONICALLY',
    ErrorSignatureCanvas = 'ERROR_SIGNATURECANVAS',
    ErrorFirstLastBlank = 'ERROR_FIRSTLASTBLANK',
    ErrorFirstLastCharLimit = 'ERROR_FIRSTLASTCHARLIMIT',
    ErrorInitialsBlank = 'ERROR_INITIALSBLANK',
    ErrorInitialsCharLimit = 'ERROR_INITIALSCHARLIMIT',
    ErrorSignatureBlank = 'ERROR_SIGNATUREBLANK',
    ErrorSignatureGeneration = 'ERROR_SIGNATUREGENERATION',
    ErrorSignatureSave = 'ERROR_SIGNATURESAVE',
    ErrorOfferLetterRender = 'ERROR_OFFERLETTERRENDER',
    Sign = 'SIGN',
    Close = 'CLOSE',
    Cancel = 'CANCEL',

    // NATIVE ESIG CERTIFICATE
    CoverPage = 'NATIVE_ESIG_COVER_PAGE',
    DocumentDetails = 'NATIVE_ESIG_DOCUMENT_DETAILS',
    DocumentName = 'NATIVE_ESIG_DOCUMENT_NAME',
    DocumentID = 'NATIVE_ESIG_DOCUMENT_ID',
    NumberOfPages = 'NATIVE_ESIG_NUMBER_OF_PAGES',
    CompanyName = 'NATIVE_ESIG_COMPANY_NAME',
    ActivationDate = 'NATIVE_ESIG_ACTIVATION_DATE',
    CompletionDate = 'NATIVE_ESIG_COMPLETION_DATE',
    SignatureDetails = 'NATIVE_ESIG_SIGNATURE_DETAILS',
    Assignee = 'NATIVE_ESIG_ASSIGNEE',
    ReferenceNumber = 'NATIVE_ESIG_REFERENCE_NUMBER',
    IPAddress = 'NATIVE_ESIG_IP_ADDRESS',
    DateAndTime = 'NATIVE_ESIG_DATE_AND_TIME',
    Signature = 'NATIVE_ESIG_SIGNATURE',
    ReferenceTimeZone = 'NATIVE_ESIG_REFERENCE_TIMEZONE',
    GeneratedOn = 'NATIVE_ESIG_GENERATED_ON',
    ErrorRenderCertificate = 'NATIVE_ESIG_RENDER_ERROR',
    ErrorGenerateCertificate = 'NATIVE_ESIG_GENERATE_ERROR',
    ErrorNetworkCertificate = 'NATIVE_ESIG_NETWORK_ERROR',

    // ATS Candidate Action Modals
    SendAnonymously = 'SEND_ANONYMOUSLY',
    CommonAgency = 'COMMON_AGENCY',
    CommonCandidate = 'COMMON_CANDIDATE',
    CommonCandidates = 'COMMON_CANDIDATES',
    CommonFrom = 'COMMON_FROM',
    CommonTo = 'COMMON_TO',
    CommonTemplate = 'COMMON_TEMPLATE',
    CommonTemplates = 'COMMON_TEMPLATES',
    CommonSubject = 'COMMON_SUBJECT',
    CommonFileUpload = 'COMMON_FILE_UPLOAD',
    CommonFileDrop = 'COMMON_FILE_DROP',
    CommonMessageSend = 'COMMON_MESSAGE_SEND',
    CommonSubjectRequired = 'COMMON_SUBJECT_IS_REQUIRED',
    CommonSendNotes = 'COMMON_SEND_NOTES',
    CommonOptional = 'COMMON_OPTIONAL',
    CommonDays = 'COMMON_DAYS',
    CommonDisposition = 'COMMON_DISPOSITION',
    CANDIDATE_MSG_NO_HIRING_MANAGER = 'CANDIDATE_MSG_NO_HIRING_MANAGER',
    CANDIDATE_MSG_NO_HM_ACTION_LECTURE1 = 'CANDIDATE_MSG_NO_HM_ACTION_LECTURE1',
    CANDIDATE_MSG_NO_HM_ACTION_LECTURE2 = 'CANDIDATE_MSG_NO_HM_ACTION_LECTURE2',
    APPLICANT_SUBMITTOHIRINGMANAGER_SUBMIT_CANDIDATE_TO_HIRING_MANAGER = 'APPLICANT_SUBMITTOHIRINGMANAGER_SUBMIT_CANDIDATE_TO_HIRING_MANAGER',
    ADD_HIRING_MANAGER = 'ADD_HIRING_MANAGER',
    JV_SENDHIRINGMANAGER_CONTROLLER_MESSAGE_GET_ERROR = 'JV_SENDHIRINGMANAGER_CONTROLLER_MESSAGE_GET_ERROR',
    JV_SENDHIRINGMANAGER_CONTROLLER_MESSAGE_SENT_ERROR = 'JV_SENDHIRINGMANAGER_CONTROLLER_MESSAGE_SENT_ERROR',
    COMMON_UPDATE_STATUS = 'COMMON_UPDATE_STATUS',
    CandidatesRejectTooltip = 'CANDIDATES_REJECT_TOOLTIP',
    AgencyCopied = 'AGENCY_COPIED',
    AgencyCandidates = 'I18N_CANDIDATES_AGENCY_COMMON',
    CommonAnd = 'COMMON_AND',
    Candidates = 'APPLICANT_CANDIDATENAVIGATION_CANDIDATE_S_',
    RequiredField = 'JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD',
    SendAnonymouslyDescription = 'JV_SENDMESSAGE_CONTROLLER_CHOOSE_THE_SEND_ANONYMOUSLY_OPTION_IF_YOU_DO_NOT_W',
    PersonalCompanyEmailTemplates = 'PERSONAL_EMAIL_TEMPLATES_COMPANY_TEMPLATES',
    PersonalUserEmailTemplates = 'PERSONAL_EMAIL_TEMPLATES_MY_TEMPLATES',
    MessageSentTo1 = 'JV_SENDMESSAGE_CONTROLLER_MESSAGE_WAS_SENT_SUCCESSFULLY_TO_1_CANDIDATE',
    MessageSentToMany = 'JV_SENDMESSAGE_CONTROLLER_MESSAGE_WAS_SENT_SUCCESSFULLY_TO_0_CANDIDATES',
    NoteAddedSuccessfully = 'JV_APPLICANT_NOTE_ADDED_SUCCESSFULLY',
    MessageSendError = 'JV_SENDMESSAGE_CONTROLLER_MEESAGE_SENT_ERROR',
    NoteSendError = 'JV_SENDNOTE_CONTROLLER_MEESAGE_SENT_ERROR',
    IncludeCandidateResumeIfAvailable = 'COMMON_INCLUDE_CANDIDATE_RESUMES',
    CandidatesHaveBeenRejected = 'JV_APPLICANT_CANDIDATES_HAVE_BEEN_REJECTED',
    CandidatesHaveBeenMoved = 'JV_APPLICANT_CANDIDATES_HAVE_BEEN_REJECTED_AND_MOVED',
    RejectionSendError = 'JV_SENDREJECTION_CONTROLLER_MESSAGE_SENT_ERROR',
    CommonRejectCandidates = 'CANDIDATE_REJECT_APPLICATIONS',
    CandidateSendRejectEmail = 'CANDIDATE_SEND_REJECTION_EMAIL',
    CandidateRejectLater = 'CANDIDATES_REJECT_LATER',
    Candidate1MissingEmail = 'CANDIDATES_MISSING_EMAIL_1',
    CandidateManyMissingEmail = 'CANDIDATES_MISSING_EMAIL_MANY',
    Agency1MissingEmail = 'AGENCY_CANDIDATES_MISSING_EMAIL_1',
    AgencyManyMissingEmail = 'AGENCY_CANDIDATES_MISSING_EMAIL_MANY',
    ChangeStatus = 'COMMON_CHANGE_STATUS',
    SelectNewStatus = 'COMMON_SELECT_NEW_STATUS',
    ChangeStatusSuccess = 'JV_APPLICANT_CANDIDATE_STATUS_UPDATED_SUCCESSFULLY',
    ChangeStatusError = 'JV_APPLICANT_CANDIDATE_STATUS_UPDATED_ERROR',
    PlusXMore = 'APPLICANT_QUICKVIEW__0_MORE',
    SourceType = 'SOURCE_TYPE',
    Applications = 'APPLICATIONS',
    JobApplied = 'HEADER_JOB',
    CommonPreview = 'COMMON_PREVIEW',
    CommonApplication = 'COMMON_APPLICATION',
    ViewDetails = 'APPLICANT_QUICKVIEW_VIEW_DETAILS',
    QuickView = 'APPLICANT_QUICKVIEW_QUICK_VIEW',
    CommonLastActivity = 'COMMON_LAST_ACTIVITY',
    HeaderStatus = 'HEADER_STATUS',
    HeaderJobMatch = 'HEADER_JOBMATCH',
    CommonMatch = 'COMMON_MATCH',
    CommonPending = 'COMMON_PENDING',
    CommonMatchNA = 'COMMON_MATCH_NA',

    // ODS
    ODS_ORGANIZATIONAL_ELEMENTS = 'ODS_ORGANIZATIONAL_ELEMENTS',
    ODS_ADMIN_CONFIGURATION = 'ODS_ADMIN_CONFIGURATION',
    ODS_ADMIN = 'ODS_ADMIN',
    ODS_CREATE_ORG_ELEMENT_DESC = 'ODS_CREATE_ORG_ELEMENT_DESC',
    ODS_CREATE_ORG_ELEMENT = 'ODS_CREATE_ORG_ELEMENT',
    ODS_ALL = 'ODS_ALL',
    ODS_SELECTED = 'ODS_SELECTED',
    ODS_TAB_BUSINESS_UNITS = 'ODS_TAB_BUSINESS_UNITS',
    ODS_TAB_LOCATIONS = 'ODS_TAB_LOCATIONS',
    ODS_TAB_DEPARTMENTS = 'ODS_TAB_DEPARTMENTS',
    ODS_SEARCH_BUSINESS_UNITS = 'ODS_SEARCH_BUSINESS_UNITS',
    ODS_SEARCH_PLACEHOLDER = 'ODS_SEARCH_PLACEHOLDER',
    ODS_SEARCH_LOCATIONS = 'ODS_SEARCH_LOCATIONS',
    ODS_SEARCH_DEPARTMENTS = 'ODS_SEARCH_DEPARTMENTS',
    ODS_SUB_BUSINESS_UNITS='ODS_SUB_BUSINESS_UNITS',
    ODS_SUB_DEPARTMENTS='ODS_SUB_DEPARTMENTS',
    ODS_SUB_LOCATIONS='ODS_SUB_LOCATIONS',
    ODS_DATE_CREATED='ODS_DATE_CREATED',
    ODS_CREATED_BY='ODS_CREATED_BY',
    ODS_STATUS='ODS_STATUS',
    ODS_DESCRIPTION='ODS_DESCRIPTION',
    ODS_ADD_BUSINESS_BUTTON='ODS_ADD_BUSINESS_BUTTON',
    ODS_ROWS_PER_PAGE_LABEL='ODS_ROWS_PER_PAGE_LABEL',
    ODS_BUSINESS_UNIT_SETTINGS='ODS_BUSINESS_UNIT_SETTINGS',
    ODS_SAVE_BUTTON_CAPTION='ODS_SAVE_BUTTON_CAPTION',
    ODS_CANCEL_BUTTON_CAPTION='ODS_CANCEL_BUTTON_CAPTION',
    ODS_DUPLICATE_CAPTION='ODS_DUPLICATE_CAPTION',
    ODS_MAKE_ACTIVE_CAPTION='ODS_MAKE_ACTIVE_CAPTION',
    ODS_MAKE_IN_ACTIVE_CAPTION='ODS_MAKE_IN_ACTIVE_CAPTION',
    ODS_BUSINESS_UNIT_NAME='ODS_BUSINESS_UNIT_NAME',
    ODS_PARENT_BUSINESS_UNIT='ODS_PARENT_BUSINESS_UNIT',
    ODS_SELECT_PARENT_BUSINESS_UNIT='ODS_SELECT_PARENT_BUSINESS_UNIT',
    ODS_DESCRIPTION_CAPTION='ODS_DESCRIPTION_CAPTION',
    ODS_CAREER_SITE_URL='ODS_CAREER_SITE_URL',
    ODS_PRIVACY_NOTICE_URL='ODS_PRIVACY_NOTICE_URL',
    ODS_REMOVE_IMAGE_BUTTON='ODS_REMOVE_IMAGE_BUTTON',
    ODS_EMAIL_LOGO='ODS_EMAIL_LOGO',
    ODS_IMAGE_UPLOAD_HELPER_TEXT='ODS_IMAGE_UPLOAD_HELPER_TEXT',
    ODS_IMAGE_UPLOAD_CAPTION='ODS_IMAGE_UPLOAD_CAPTION',
    ODS_UPLOAD_IMAGE_BUTTON='ODS_UPLOAD_IMAGE_BUTTON',
    ODS_SOCIAL_MEDIA_LOGO='ODS_SOCIAL_MEDIA_LOGO',
    ODS_TWITTER_LOGO='ODS_TWITTER_LOGO',
    ODS_OKAY_BUTTON_TEXT='ODS_OKAY_BUTTON_TEXT',
    ODS_IMAGE_UPLOAD_ERROR_TEXT='ODS_IMAGE_UPLOAD_ERROR_TEXT',
    ODS_IMAGE_UPLOAD_HELPER_TEXT_1='ODS_IMAGE_UPLOAD_HELPER_TEXT_1',
    ODS_IMAGE_UPLOAD_HELPER_TEXT_2='ODS_IMAGE_UPLOAD_HELPER_TEXT_2',
    ODS_LEAVE_FORM_CONFIRMATION_DESC='ODS_LEAVE_FORM_CONFIRMATION_DESC',
    ODS_LEAVE_FORM_CONFIRMATION_TITLE='ODS_LEAVE_FORM_CONFIRMATION_TITLE',
    ODS_REMOVE_EMPLOYEE_FROM_ACCESS_GROUP_CONFIRMATION_TITLE='ODS_REMOVE_EMPLOYEE_FROM_ACCESS_GROUP_CONFIRMATION_TITLE',
    ODS_REMOVE_EMPLOYEE_FROM_ACCESS_GROUP_CONFIRMATION_DESC='ODS_REMOVE_EMPLOYEE_FROM_ACCESS_GROUP_CONFIRMATION_DESC',
    ODS_BU_NAME_REQUIRED='ODS_BU_NAME_REQUIRED',
    ODS_PARENT_BU_REQUIRED='ODS_PARENT_BU_REQUIRED',
    ODS_BU_SUBMITTED_SUCCESSFULLY='ODS_BU_SUBMITTED_SUCCESSFULLY',
    ODS_BU_SUBMIT_FAILED='ODS_BU_SUBMIT_FAILED',
    ODS_BU_UDATED_SUCCESSFULLY='ODS_BU_UDATED_SUCCESSFULLY',
    ODS_BU_UPDATE_FAILED='ODS_BU_UPDATE_FAILED',
    ODS_BU_DUPLICATE_NAME_ERROR='ODS_BU_DUPLICATE_NAME_ERROR',
    ODS_ACTIONS_ADD_BU = 'ODS_ACTIONS_ADD_BU',
    ODS_ACTIONS_EDIT = 'ODS_ACTIONS_EDIT',
    ODS_ACTIONS_DUPLICATE = 'ODS_ACTIONS_DUPLICATE',
    ODS_ACTIONS_MAKE_INACTIVE = 'ODS_ACTIONS_MAKE_INACTIVE',
    ODS_ACTIONS_MAKE_ACTIVE = 'ODS_ACTIONS_MAKE_ACTIVE',
    I18N_NO_RESULTS_FOUND = 'I18N_NO_RESULTS_FOUND',
    ODS_INACTIVATE_BU_WITH_SUBSIDIARIES_CONFIRMATION_DESC = 'ODS_INACTIVATE_BU_WITH_SUBSIDIARIES_CONFIRMATION_DESC',
    ODS_MAKE_BU_INACTIVATE_SUCCESSFUL = 'ODS_MAKE_BU_INACTIVATE_SUCCESSFUL',
    ODS_MAKE_BU_WITH_SUBSIDIARIES_INACTIVATE_SUCCESSFUL = 'ODS_MAKE_BU_WITH_SUBSIDIARIES_INACTIVATE_SUCCESSFUL',
    ODS_UPDATE_BU_MODAL_TITLE = 'ODS_UPDATE_BU_MODAL_TITLE',
    ODS_ACTIVATE_BU_WITH_SUBSIDIARIES_CONFIRMATION_DESC = 'ODS_ACTIVATE_BU_WITH_SUBSIDIARIES_CONFIRMATION_DESC',
    ODS_MAKE_BU_ACTIVATE_SUCCESSFUL = 'ODS_MAKE_BU_ACTIVATE_SUCCESSFUL',
    ODS_ACTIONS_ADD_DEPARTMENT =  'ODS_ACTIONS_ADD_DEPARTMENT',
    ODS_ACTIONS_ADD_SUB_DEPARTMENT = 'ODS_ACTIONS_ADD_SUB_DEPARTMENT',
    ODS_DELETE = 'ODS_DELETE',
    ODS_DEPARTMENT_SETTINGS = 'ODS_DEPARTMENT_SETTINGS',
    ODS_DEPARTMENT_NAME = 'ODS_DEPARTMENT_NAME',
    ODS_PARENT_DEPARTMENT = 'ODS_PARENT_DEPARTMENT',
    ODS_SELECT_PARENT_DEPARTMENT = 'ODS_SELECT_PARENT_DEPARTMENT',
    ODS_ERROR_FETCHING_RESUTS = 'ODS_ERROR_FETCHING_RESUTS',
    ODS_DEPARTMENT_NAME_REQUIRED = 'ODS_DEPARTMENT_NAME_REQUIRED',
    ODS_DEPARTMENT_SUBMITTED_SUCCESSFULLY = 'ODS_DEPARTMENT_SUBMITTED_SUCCESSFULLY',
    ODS_DEPARTMENT_SUBMIT_FAILED = 'ODS_DEPARTMENT_SUBMIT_FAILED',
    ODS_DEPARTMENT_UDATED_SUCCESSFULLY = 'ODS_DEPARTMENT_UDATED_SUCCESSFULLY',
    ODS_DEPARTMENT_UPDATE_FAILED = 'ODS_DEPARTMENT_UPDATE_FAILED',
    ODS_DEPARTMENT_DELETE_FAILED = 'ODS_DEPARTMENT_DELETE_FAILED',
    ODS_DEPARTMENT_DELETE_SUCCESSFULLY = 'ODS_DEPARTMENT_DELETE_SUCCESSFULLY',
    ODS_DEPARTMENT_DUPLICATE_NAME_ERROR = 'ODS_DEPARTMENT_DUPLICATE_NAME_ERROR',
    ODS_DEPARTMENT_SUBSIDIARIES_INACTIVATE_SUCCESSFUL = 'ODS_DEPARTMENT_SUBSIDIARIES_INACTIVATE_SUCCESSFUL',
    ODS_UPDATE_DEPARTMENT_MODAL_TITLE = 'ODS_UPDATE_DEPARTMENT_MODAL_TITLE',
    ODS_ACTIVATE_DEPARTMENT_DESCRIPTION = 'ODS_ACTIVATE_DEPARTMENT_DESCRIPTION',
    ODS_INACTIVATE_DEPARTMENT_CONFIRMATION_DESC = 'ODS_INACTIVATE_DEPARTMENT_CONFIRMATION_DESC',
    ODS_DEPARTMENT_REQ_LINK_ERROR = 'ODS_DEPARTMENT_REQ_LINK_ERROR',
    ODS_DEPARTMENT_CHILD_DEP_ERROR = 'ODS_DEPARTMENT_CHILD_DEP_ERROR',
    ODS_DEPARTMENT_DELETE_CONFIRM = 'ODS_DEPARTMENT_DELETE_CONFIRM',
    ODS_DEPARTMENT_DELETE_CONFIRM_TITLE = 'ODS_DEPARTMENT_DELETE_CONFIRM_TITLE',
    ODS_ACTIONS_ADD_SUB_LOCATION = 'ODS_ACTIONS_ADD_SUB_LOCATION',
    ODS_ACTIONS_ADD_LOCATION = 'ODS_ACTIONS_ADD_LOCATION',
    ODS_LOCATION_SETTINGS_TITLE = 'ODS_LOCATION_SETTINGS_TITLE',
    ODS_LOCATION_DETAILS = 'ODS_LOCATION_DETAILS',
    ODS_LOCATION_PARENT = 'ODS_LOCATION_PARENT',
    ODS_LOCATION_NAME = 'ODS_LOCATION_NAME',
    ODS_LOCATION_REMOTE = 'ODS_LOCATION_REMOTE',
    ODS_LOCATION_SELECT_PARENT = 'ODS_LOCATION_SELECT_PARENT',
    ODS_LOCATION_NAME_REQUIRED = 'ODS_LOCATION_NAME_REQUIRED',
    ODS_LOCATION_DUPLICATE_NAME_ERROR = 'ODS_LOCATION_DUPLICATE_NAME_ERROR',
    ODS_LOCATION_SUBMITTED_SUCCESSFULLY = 'ODS_LOCATION_SUBMITTED_SUCCESSFULLY',
    ODS_LOCATION_SUBMIT_FAILED = 'ODS_LOCATION_SUBMIT_FAILED',
    ODS_LOCATION_UDATED_SUCCESSFULLY = 'ODS_LOCATION_UDATED_SUCCESSFULLY',
    ODS_LOCATION_UPDATE_FAILED = 'ODS_LOCATION_UPDATE_FAILED',
    ODS_LOCATION_DELETE_SUCCESSFULLY = 'ODS_LOCATION_DELETE_SUCCESSFULLY',
    ODS_LOCATION_DELETE_FAILED = 'ODS_LOCATION_DELETE_FAILED',
    ODS_LOCATION_OFFICE = 'ODS_LOCATION_OFFICE',
    ODS_LOCATION_ADDRESS = 'ODS_LOCATION_ADDRESS',
    ODS_LOCATION_COUNTRY = 'ODS_LOCATION_COUNTRY',
    ODS_LOCATION_ADDRESS_1 = 'ODS_LOCATION_ADDRESS_1',
    ODS_LOCATION_ADDRESS_2 = 'ODS_LOCATION_ADDRESS_2',
    ODS_LOCATION_CITY = 'ODS_LOCATION_CITY',
    ODS_LOCATION_STATE = 'ODS_LOCATION_STATE',
    ODS_LOCATION_ZIP_CODE = 'ODS_LOCATION_ZIP_CODE',
    ODS_LOCATION_ADD = 'ODS_LOCATION_ADD',
    ODS_LOCATION_SELECT = 'ODS_LOCATION_SELECT',
    ODS_DATE_TIME_LANGUAGE_TITLE = 'ODS_DATE_TIME_LANGUAGE_TITLE',
    ODS_TIMEZONE = 'ODS_TIMEZONE',
    ODS_LANGUAGE = 'ODS_LANGUAGE',
    ODS_SHORT_DATE_FORMAT = 'ODS_SHORT_DATE_FORMAT',
    ODS_LONG_DATE_FORMAT = 'ODS_LONG_DATE_FORMAT',
    ODS_SHORT_TIME_FORMAT = 'ODS_SHORT_TIME_FORMAT',
    ODS_LONG_TIME_FORMAT = 'ODS_LONG_TIME_FORMAT',
    ODS_NUMBER_FORMAT = 'ODS_NUMBER_FORMAT',
    ODS_LOCATION_DELETE_CONFIRM_TITLE = 'ODS_LOCATION_DELETE_CONFIRM_TITLE',
    ODS_LOCATION_DELETE_CONFIRM = 'ODS_LOCATION_DELETE_CONFIRM',
    ODS_LOCATION_REQ_LINK_ERROR = 'ODS_LOCATION_REQ_LINK_ERROR',
    ODS_LOCATION_CHILD_ERROR = 'ODS_LOCATION_CHILD_ERROR',
    ODS_UPDATE_LOCATION_MODAL_TITLE = 'ODS_UPDATE_LOCATION_MODAL_TITLE',
    ODS_ACTIVATE_LOCATION_DESCRIPTION = 'ODS_ACTIVATE_LOCATION_DESCRIPTION',
    ODS_INACTIVATE_LOCATION_CONFIRMATION_DESC = 'ODS_INACTIVATE_LOCATION_CONFIRMATION_DESC',
    ODS_LOCATION_SUBSIDIARIES_INACTIVATE_SUCCESSFUL = 'ODS_LOCATION_SUBSIDIARIES_INACTIVATE_SUCCESSFUL',
    // Automation Engine
    AUTOMATION_FORM_SAVE = 'AUTOMATION_FORM_SAVE',
    AUTOMATION_FORM_CONFIRM = 'AUTOMATION_FORM_CONFIRM',
    HEADER_NAME = 'HEADER_NAME',
    HEADER_STATUS = 'HEADER_STATUS',
    HEADER_TYPE = 'HEADER_TYPE',
    HEADER_TRIGGER = 'HEADER_TRIGGER',
    HEADER_CONDITION = 'HEADER_CONDITION',
    HEADER_ACTION = 'HEADER_ACTION',
    HEADER_LASTUPDATED = 'HEADER_LASTUPDATED',
    AUTOMATION_TITLE = 'AUTOMATION_TITLE',
    FIELD_LIST_TITLE = 'FIELD_LIST_TITLE',
    FIELD_LIST_DESCRIPTION = 'FIELDLISTS',
    AUTOMATION_DESCRIPTION = 'AUTOMATION_DESCRIPTION',
    AUTOMATION_CREATE_BUTTON = 'AUTOMATION_CREATE_BUTTON',
    AUTOMATION_SEARCH = 'AUTOMATION_SEARCH',
    AUTOMATION_LAST_UPDATED = 'AUTOMATION_LAST_UPDATED',
    AUTOMATION_STATUS = 'AUTOMATION_STATUS',
    AUTOMATION_STATUS_ALL = 'AUTOMATION_STATUS_ALL',
    AUTOMATION_STATUS_ACTIVE = 'AUTOMATION_STATUS_ACTIVE',
    AUTOMATION_STATUS_INACTIVE = 'AUTOMATION_STATUS_INACTIVE',
    AUTOMATION_STATUS_MAKE = 'AUTOMATION_STATUS_MAKE',
    AUTOMATION_STATUS_MAKE_INACTIVE = 'AUTOMATION_STATUS_MAKE_INACTIVE',
    AUTOMATION_STATUS_MAKE_ACTIVE = 'AUTOMATION_STATUS_MAKE_ACTIVE',
    AUTOMATION_STATUS_MAKE_ACTIVE_SUBTITLE = 'AUTOMATION_STATUS_MAKE_ACTIVE_SUBTITLE',
    AUTOMATION_STATUS_MAKE_INACTIVE_SUBTITLE = 'AUTOMATION_STATUS_MAKE_INACTIVE_SUBTITLE',
    AUTOMATION_TYPE_AUTO = 'AUTOMATION_TYPE_AUTO',
    AUTOMATION_TYPE_ONDEMAND = 'AUTOMATION_TYPE_ONDEMAND',
    AUTOMATION_TYPE_ONDEMAND_DESC = 'AUTOMATION_TYPE_ONDEMAND_DESC',
    AUTOMATION_SECTION_WHENTHISHAPPENS = 'AUTOMATION_SECTION_WHENTHISHAPPENS',
    AUTOMATION_SECTION_CONTINUEIF = 'AUTOMATION_SECTION_CONTINUEIF',
    AUTOMATION_SECTION_THENDOTHIS = 'AUTOMATION_SECTION_THENDOTHIS',
    AUTOMATION_SECTION_RUN_SECONDARY = 'AUTOMATION_SECTION_RUN_SECONDARY',
    AUTOMATION_SECTION_NONE_SELECTED = 'AUTOMATION_SECTION_NONE_SELECTED',
    AUTOMATION_UPDATEDBY = 'AUTOMATION_UPDATEDBY',
    AUTOMATION_FORM_IS = 'AUTOMATION_FORM_IS',
    AUTOMATION_FORM_IS_NOT = 'AUTOMATION_FORM_IS_NOT',
    AUTOMATION_FORM_OR = 'AUTOMATION_FORM_OR',
    AUTOMATION_FORM_AND = 'AUTOMATION_FORM_AND',
    AUTOMATION_FORM_TITLE = 'AUTOMATION_FORM_TITLE',
    AUTOMATION_EDIT_TITLE = 'AUTOMATION_EDIT_TITLE',
    AUTOMATION_FORM_NAME = 'AUTOMATION_FORM_NAME',
    AUTOMATION_FORM_TYPE = 'AUTOMATION_FORM_TYPE',
    AUTOMATION_FORM_TRIGGER = 'AUTOMATION_FORM_TRIGGER',
    AUTOMATION_FORM_CONDITION = 'AUTOMATION_FORM_CONDITION',
    AUTOMATION_FORM_ACTION = 'AUTOMATION_FORM_ACTION',
    AUTOMATION_FORM_ACCOUNT = 'AUTOMATION_FORM_ACCOUNT',
    AUTOMATION_ROWS_PER_PAGE = 'AUTOMATION_ROWS_PER_PAGE',
    AUTOMATION_LIST_ERROR_FETCH = 'AUTOMATION_LIST_ERROR_FETCH',
    AUTOMATION_FORM_ERROR_TRIGGERS = 'AUTOMATION_FORM_ERROR_TRIGGERS',
    AUTOMATION_FORM_ERROR_CONTINUE = 'AUTOMATION_FORM_ERROR_CONTINUE',
    AUTOMATION_FORM_ERROR_ACTION = 'AUTOMATION_FORM_ERROR_ACTION',
    AUTOMATION_LIST_NO_RESULTS = 'AUTOMATION_LIST_NO_RESULTS',
    AUTOMATION_INPUT_NO_OPTIONS = 'AUTOMATION_INPUT_NO_OPTIONS',
    AUTOMATION_FILTER_OPERATOR_ONE = 'AUTOMATION_FILTER_OPERATOR_ONE',
    AUTOMATION_FILTER_OPERATOR_NOT = 'AUTOMATION_FILTER_OPERATOR_NOT',
    AUTOMATION_FORM_ALERT_MESSAGE_SUCCESS = 'AUTOMATION_FORM_ALERT_MESSAGE_SUCCESS',
    AUTOMATION_FORM_ALERT_MESSAGE_ERROR = 'AUTOMATION_FORM_ALERT_MESSAGE_ERROR',
    AUTOMATION_EDIT_ALERT_MESSAGE_SUCCESS = 'AUTOMATION_EDIT_ALERT_MESSAGE_SUCCESS',
    AUTOMATION_EDIT_ALERT_MESSAGE_ERROR = 'AUTOMATION_EDIT_ALERT_MESSAGE_ERROR',
    AUTOMATION_TRIGGER_REQUISITION = 'AUTOMATION_TRIGGER_REQUISITION',
    AUTOMATION_TRIGGER_CANDIDATE = 'AUTOMATION_TRIGGER_CANDIDATE',
    AUTOMATION_TRIGGER_REQ_STATUS_CHANGE = 'AUTOMATION_TRIGGER_REQ_STATUS_CHANGE',
    AUTOMATION_FILTER_REQ_CATEGORY = 'AUTOMATION_FILTER_REQ_CATEGORY',
    AUTOMATION_FILTER_REQ_DEPARTMENT = 'AUTOMATION_FILTER_REQ_DEPARTMENT',
    AUTOMATION_FILTER_REQ_JOB_TYPE = 'AUTOMATION_FILTER_REQ_JOB_TYPE',
    AUTOMATION_FILTER_REQ_JOB_LOCATION = 'AUTOMATION_FILTER_REQ_JOB_LOCATION',
    AUTOMATION_FILTER_REQ_STATUS = 'AUTOMATION_FILTER_REQ_STATUS',
    AUTOMATION_FILTER_APPLICATION_ACTIVITY = 'AUTOMATION_FILTER_APPLICATION_ACTIVITY',
    AUTOMATION_FILTER_COMPANY_NAME = 'AUTOMATION_FILTER_COMPANY_NAME',
    AUTOMATION_FILTER_REQ_WORKFLOW='AUTOMATION_FILTER_REQ_WORKFLOW',
    AUTOMATION_FILTER_ACTIVE_APPLICATIONS = 'AUTOMATION_FILTER_ACTIVE_APPLICATIONS',
    AUTOMATION_ACTION_DISPOSITION_CANDIDATE = 'AUTOMATION_ACTION_DISPOSITION_CANDIDATE',
    AUTOMATION_ACTION_EMAIL_CANDIDATE = 'AUTOMATION_ACTION_EMAIL_CANDIDATE',
    AUTOMATION_ACTION_FIELD_CANDIDATE_EMAIL_TEMPLATE_ID = 'AUTOMATION_ACTION_FIELD_CANDIDATE_EMAIL_TEMPLATE_ID',
    AUTOMATION_ACTION_FIELD_CANDIDATE_WORKFLOW_STATE_TITLE = 'AUTOMATION_ACTION_FIELD_CANDIDATE_WORKFLOW_STATE_TITLE',
    AUTOMATION_ACTION_FIELD_CANDIDATE_DISPOSITION_ID = 'AUTOMATION_ACTION_FIELD_CANDIDATE_DISPOSITION_ID',
    AUTOMATION_ACTION_CHANGE_CANDIDATE_WORKFLOW_STATE = 'AUTOMATION_ACTION_CHANGE_CANDIDATE_WORKFLOW_STATE',
    AUTOMATION_SECTION_ADD_ACTION='AUTOMATION_SECTION_ADD_ACTION',
    AUTOMATION_SECTION_ADD_CONDITION='AUTOMATION_SECTION_ADD_CONDITION',
    AUTOMATION_USER_TOOLTIP='AUTOMATION_USER_TOOLTIP',
    AUTOMATION_TYPE_TOOLTIP='AUTOMATION_TYPE_TOOLTIP',
    AUTOMATION_FILTER_CANDIDATE_WORKFLOW_STATE='AUTOMATION_FILTER_CANDIDATE_WORKFLOW_STATE',
    AUTOMATION_FILTER_CANDIDATE_DAYS_ON_WORKFLOW_STATE='AUTOMATION_FILTER_CANDIDATE_DAYS_ON_WORKFLOW_STATE',
    AUTOMATION_FILTER_DAYS_ON_WORKFLOW_STATE='AUTOMATION_FILTER_DAYS_ON_WORKFLOW_STATE',
    AUTOMATION_TRIGGER_CANDIDATE_WORKFLOW_STATE='AUTOMATION_TRIGGER_CANDIDATE_WORKFLOW_STATE',
    AUTOMATION_VERSION_LOG='AUTOMATION_VERSION_LOG',
    AUTOMATION_RUN_LOG='AUTOMATION_RUN_LOG',
    AUTOMATION_EDIT='AUTOMATION_EDIT',
    AUTOMATION_OVERVIEW='AUTOMATION_OVERVIEW',
    AUTOMATION_VERSION_LOG_HEADER_USER = 'AUTOMATION_VERSION_LOG_HEADER_USER',
    AUTOMATION_VERSION_LOG_HEADER_MODIFIED_DATE = 'AUTOMATION_VERSION_LOG_HEADER_MODIFIED_DATE',
    AUTOMATION_VERSION_LOG_HEADER_FIELD_LABEL = 'AUTOMATION_VERSION_LOG_HEADER_FIELD_LABEL',
    AUTOMATION_VERSION_LOG_HEADER_OLD_VALUE = 'AUTOMATION_VERSION_LOG_HEADER_OLD_VALUE',
    AUTOMATION_VERSION_LOG_HEADER_NEW_VALUE = 'AUTOMATION_VERSION_LOG_HEADER_NEW_VALUE',
    AUTOMATION_FORM_COMPANY_FILTERS = 'AUTOMATION_FORM_COMPANY_FILTERS',
    AUTOMATION_FORM_SERVICE_ACCOUNT_USER = 'AUTOMATION_FORM_SERVICE_ACCOUNT_USER',
    AUTOMATION_FORM_COMPANY_ACTIONS = 'AUTOMATION_FORM_COMPANY_ACTIONS',
    AUTOMATION_FORM_LINKED_AUTOMATIONS = 'AUTOMATION_FORM_LINKED_AUTOMATIONS',
    AUTOMATION_VERSION_LOG_EDIT_DESCRIPTION = 'AUTOMATION_VERSION_LOG_EDIT_DESCRIPTION',
    AUTOMATION_VERSION_LOG_EXPAND_ROW_LABEL = 'AUTOMATION_VERSION_LOG_EXPAND_ROW_LABEL',
    AUTOMATION_VERSION_LOG_COLLAPSE_ROW_LABEL = 'AUTOMATION_VERSION_LOG_COLLAPSE_ROW_LABEL',
    REQ_STATUS_CHANGE = 'REQ_STATUS_CHANGE',
    CANDIDATE_WORKFLOW_STATE = 'CANDIDATE_WORKFLOW_STATE',
    //Field Lists
    FIELD_LIST_FORM_ALERT_MESSAGE_ERROR = 'FIELD_LIST_FORM_ALERT_MESSAGE_ERROR',
    FIELD_LIST_FORM_ALERT_MESSAGE_SUCCESS = 'FIELD_LIST_FORM_ALERT_MESSAGE_SUCCESS',
    FIELD_LIST_EDIT_ALERT_MESSAGE_SUCCESS = 'FIELD_LIST_EDIT_ALERT_MESSAGE_SUCCESS',
    FIELD_LIST_EDIT_ALERT_MESSAGE_ERROR = 'FIELD_LIST_EDIT_ALERT_MESSAGE_ERROR',
    FIELD_LIST_FORM_VALUE = 'FIELD_LIST_FORM_VALUE',
    FIELD_LIST_FORM_NAME = 'FIELD_LIST_FORM_NAME',
    FIELD_LIST_EDIT_TITLE = 'FIELD_LIST_EDIT_TITLE',
    FIELD_LIST_FORM_TITLE = 'FIELD_LIST_FORM_TITLE',
    FIELD_LIST_CREATE_BUTTON = 'FIELD_LIST_CREATE_BUTTON',
    FIELD_LIST_DISCLAIMERS = 'FIELD_LIST_DISCLAIMERS',
    FIELD_LIST_ADD_VALUE = 'FIELD_LIST_ADD_VALUE',
    FIELD_LIST_VALUES = 'FIELD_LIST_VALUES',
    FIELD_LIST_MAXIMUM_CAPACITY = 'FIELD_LIST_MAXIMUM_CAPACITY',
    FIELD_LIST_ROWS_PER_PAGE = 'FIELD_LIST_ROWS_PER_PAGE',
    FIELD_LIST_EDIT = 'FIELD_LIST_EDIT',
    FIELD_LIST_STATUS_MAKE = 'FIELD_LIST_STATUS_MAKE',
    FIELD_LIST_STATUS_ACTIVE = 'FIELD_LIST_STATUS_ACTIVE',
    FIELD_LIST_STATUS_INACTIVE = 'FIELD_LIST_STATUS_INACTIVE',
    FIELD_LIST_ERROR_FETCH = 'FIELD_LIST_ERROR_FETCH',
    FIELD_LIST_NO_RESULTS = 'FIELD_LIST_NO_RESULTS',
    FIELD_LIST_UPDATEDBY = 'FIELD_LIST_UPDATEDBY',
    FIELD_LIST_STATUS_MAKE_INACTIVE = 'FIELD_LIST_STATUS_MAKE_INACTIVE',
    FIELD_LIST_STATUS_MAKE_INACTIVE_SUBTITLE = 'FIELD_LIST_STATUS_MAKE_INACTIVE_SUBTITLE',
    FIELD_LIST_STATUS_MAKE_INACTIVE_GO_TO_AUTOMATIONS = 'FIELD_LIST_STATUS_MAKE_INACTIVE_GO_TO_AUTOMATIONS',

    // Access Group
    ADMIN_USERS='ADMIN_USERS',
    ACCESS_GROUPS_MANAGE_CAPTION='ACCESS_GROUPS_MANAGE_CAPTION',
    ACCESS_GROUPS_PAGE_DESCRIPTION='ACCESS_GROUPS_PAGE_DESCRIPTION',
    ACCESS_GROUPS_ADD_BUTTON='ACCESS_GROUPS_ADD_BUTTON',
    ACCESS_GROUPS_SEARCH_LABEL='ACCESS_GROUPS_SEARCH_LABEL',
    ACCESS_GROUPS_ROWS_PER_PAGE='ACCESS_GROUPS_ROWS_PER_PAGE',
    ACCESS_GROUPS_GROUP_CAPTION='ACCESS_GROUPS_GROUP_CAPTION',
    ACCESS_GROUPS_DESCRIPTION_CAPTION='ACCESS_GROUPS_DESCRIPTION_CAPTION',
    ACCESS_GROUPS_TOTAL_USERS_CAPTION='ACCESS_GROUPS_TOTAL_USERS_CAPTION',
    ACCESS_GROUPS_STATUS_CAPTION='ACCESS_GROUPS_STATUS_CAPTION',
    ODS_ACCESS_GROUP_UPDATE_FAILED='ODS_ACCESS_GROUP_UPDATE_FAILED',
    ACCESS_GROUP_SETTINGS='ACCESS_GROUP_SETTINGS',
    ACCESS_GROUP_UPDATE='ACCESS_GROUP_UPDATE',
    ACCESS_GROUP_DETAILS='ACCESS_GROUP_DETAILS',
    ACCESS_GROUP_EMPLOYEE='ACCESS_GROUP_EMPLOYEE',
    ACCESS_SEARCH_USERS='ACCESS_SEARCH_USERS',
    COMMON_NAME='COMMON_NAME',
    ACCESS_GROUP_OTHER='ACCESS_GROUP_OTHER',
    ACCESS_GROUP_ROLES='ACCESS_GROUP_ROLES',
    ACCESS_GROUP_NAME='ACCESS_GROUP_NAME',
    ACCESS_GROUP_CODE='ACCESS_GROUP_CODE',
    ACCESS_GROUP_DESCRIPTION='ACCESS_GROUP_DESCRIPTION',
    ACCESS_GROUP_EDIT_LOCATIONS='ACCESS_GROUP_EDIT_LOCATIONS',
    ACCESS_GROUP_EDIT_BUSINESS_UNITS='ACCESS_GROUP_EDIT_BUSINESS_UNITS',
    ACCESS_GROUP_EDIT_DEPARTMENTS='ACCESS_GROUP_EDIT_DEPARTMENTS',
    ACCESS_GROUP_ADD_BUSINESS_UNITS_MODAL_TITLE='ACCESS_GROUP_ADD_BUSINESS_UNITS_MODAL_TITLE',
    ACCESS_GROUP_ADD_BUSINESS_UNITS_BUTTON_CAPTION='ACCESS_GROUP_ADD_BUSINESS_UNITS_BUTTON_CAPTION',
    ACCESS_GROUP_ADD_DEPARTMENTS_MODAL_TITLE='ACCESS_GROUP_ADD_DEPARTMENTS_MODAL_TITLE',
    ACCESS_GROUP_ADD_DEPARTMENTS_BUTTON_CAPTION='ACCESS_GROUP_ADD_DEPARTMENTS_BUTTON_CAPTION',
    ACCESS_GROUP_ADD_LOCATIONS_MODAL_TITLE='ACCESS_GROUP_ADD_LOCATIONS_MODAL_TITLE',
    ACCESS_GROUP_ADD_LOCATIONS_BUTTON_CAPTION='ACCESS_GROUP_ADD_LOCATIONS_BUTTON_CAPTION',
    ACCESS_GROUP_ADDED_SUCCESSFULLY ='ACCESS_GROUP_ADDED_SUCCESSFULLY',
    ACCESS_GROUP_ADD_FAILED='ACCESS_GROUP_ADD_FAILED',
    ACCESS_GROUP_UPDATE_SUCCESSFULLY ='ACCESS_GROUP_UPDATE_SUCCESSFULLY',
    ACCESS_GROUP_UPDATE_FAILED='ACCESS_GROUP_UPDATE_FAILED',
    ACCESS_GROUP_NAME_REQUIRED='ACCESS_GROUP_NAME_REQUIRED',
    ACCESS_GROUP_CODE_REQUIRED='ACCESS_GROUP_CODE_REQUIRED',
    ACCESS_GROUP_DUPLICATE_NAME_ERROR='ACCESS_GROUP_DUPLICATE_NAME_ERROR',
    ACCESS_GROUP_ADD_EMPLOYEES='ACCESS_GROUP_ADD_EMPLOYEES',
    ACCESS_GROUP_ADD_EMPLOYEES_INFO='ACCESS_GROUP_ADD_EMPLOYEES_INFO',
    ACCESS_GROUP_REMOVE='ACCESS_GROUP_REMOVE',
    ACCESS_GROUP_SELECTED='ACCESS_GROUP_SELECTED',
    EMPLOYEE_ACCESS_GROUP_CODE='EMPLOYEE_ACCESS_GROUP_CODE',
    ACCESS_GROUP_DIMENSION_INFO_MESSAGE='ACCESS_GROUP_DIMENSION_INFO_MESSAGE',

    // Run Log
    RUN_LOG_ROWS_PER_PAGE = 'RUN_LOG_ROWS_PER_PAGE',
    RUN_LOG_ERROR_LOADING_LIST = 'RUN_LOG_ERROR_LOADING_LIST',
    RUN_LOG_HEADER_USER = 'RUN_LOG_HEADER_USER',
    RUN_LOG_HEADER_STATUS = 'RUN_LOG_HEADER_STATUS',
    RUN_LOG_HEADER_NR_AFFECTED = 'RUN_LOG_HEADER_NR_AFFECTED',
    RUN_LOG_HEADER_LAST_RUN = 'RUN_LOG_HEADER_LAST_RUN',
    RUN_LOG_STATUS_STARTED = 'RUN_LOG_STATUS_STARTED',
    RUN_LOG_STATUS_COMPLETED = 'RUN_LOG_STATUS_COMPLETED',
    RUN_LOG_STATUS_COMPLETED_WITH_ERRORS = 'RUN_LOG_STATUS_COMPLETED_WITH_ERRORS',
    RUN_LOG_STATUS_FAILED = 'RUN_LOG_STATUS_FAILED',
    RUN_LOG_NOTES_ABOUT_THIS_RUN = 'RUN_LOG_NOTES_ABOUT_THIS_RUN',
    RUN_LOG_DESCRIPTION_FOR_STARTED = 'RUN_LOG_DESCRIPTION_FOR_STARTED',
    RUN_LOG_DESCRIPTION_FOR_COMPLETED = 'RUN_LOG_DESCRIPTION_FOR_COMPLETED',
    RUN_LOG_DESCRIPTION_FOR_COMPLETED_WITH_ERRORS = 'RUN_LOG_DESCRIPTION_FOR_COMPLETED_WITH_ERRORS',
    RUN_LOG_DESCRIPTION_FOR_FAILED = 'RUN_LOG_DESCRIPTION_FOR_FAILED',
    RUN_LOG_DOWNLOAD_LABEL = 'RUN_LOG_DOWNLOAD_LABEL',
    RUN_LOG_EXPAND_ROW_LABEL = 'RUN_LOG_EXPAND_ROW_LABEL',
    RUN_LOG_COLLAPSE_ROW_LABEL = 'RUN_LOG_COLLAPSE_ROW_LABEL'
}